__turbopack_context__.v({
  "appear-slide-left": "FeatureItem-module-scss-module__PJ1Gha__appear-slide-left",
  "bounceTwice": "FeatureItem-module-scss-module__PJ1Gha__bounceTwice",
  "fade-in-bottom": "FeatureItem-module-scss-module__PJ1Gha__fade-in-bottom",
  "fade-in-left": "FeatureItem-module-scss-module__PJ1Gha__fade-in-left",
  "fade-in-right": "FeatureItem-module-scss-module__PJ1Gha__fade-in-right",
  "fadeIn": "FeatureItem-module-scss-module__PJ1Gha__fadeIn",
  "feature": "FeatureItem-module-scss-module__PJ1Gha__feature",
  "loader": "FeatureItem-module-scss-module__PJ1Gha__loader",
  "puff-in-center": "FeatureItem-module-scss-module__PJ1Gha__puff-in-center",
  "puff-in-left": "FeatureItem-module-scss-module__PJ1Gha__puff-in-left",
  "pulse": "FeatureItem-module-scss-module__PJ1Gha__pulse",
  "pulse-contact": "FeatureItem-module-scss-module__PJ1Gha__pulse-contact",
  "shake-bottom": "FeatureItem-module-scss-module__PJ1Gha__shake-bottom",
  "slide-again": "FeatureItem-module-scss-module__PJ1Gha__slide-again",
  "slide-in-right": "FeatureItem-module-scss-module__PJ1Gha__slide-in-right",
  "slide-right": "FeatureItem-module-scss-module__PJ1Gha__slide-right",
  "stepContent-entrance": "FeatureItem-module-scss-module__PJ1Gha__stepContent-entrance",
});
